import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TableRowDetail {
  elementId: string;
  invoiceNfe: string | null;
  invoiceXml: string | null;
  paymentSlipFile?: string;
}

export interface TableSelectionState {
  selectedRows: string[];
  selectedRowDetails: TableRowDetail[];
  allSelected: boolean;
  noneSelected: boolean;
}

const initialState: TableSelectionState = {
  selectedRows: [],
  selectedRowDetails: [],
  allSelected: false,
  noneSelected: false,
};

const tableSelectionSlice = createSlice({
  name: 'tableSelection',
  initialState,
  reducers: {
    setSelectedRows(state, action: PayloadAction<string[]>) {
      state.selectedRows = action.payload;
      state.allSelected = false;
      state.noneSelected = action.payload.length === 0;
    },
    addSelectedRow(state, action: PayloadAction<string>) {
      if (!state.selectedRows.includes(action.payload)) {
        state.selectedRows.push(action.payload);
        state.noneSelected = false;
      }
    },
    removeSelectedRow(state, action: PayloadAction<string>) {
      state.selectedRows = state.selectedRows.filter(id => id !== action.payload);
      state.noneSelected = state.selectedRows.length === 0;
    },
    clearSelectedRows(state) {
      state.selectedRows = [];
      state.selectedRowDetails = [];
      state.allSelected = false;
      state.noneSelected = true;
    },
    setSelectedRowDetails(state, action: PayloadAction<TableRowDetail[]>) {
      state.selectedRowDetails = action.payload;
    },
    addSelectedRowDetail(state, action: PayloadAction<TableRowDetail>) {
      if (!state.selectedRowDetails.some(row => row.elementId === action.payload.elementId)) {
        state.selectedRowDetails.push(action.payload);
      }
    },
    removeSelectedRowDetail(state, action: PayloadAction<string>) {
      state.selectedRowDetails = state.selectedRowDetails.filter(row => row.elementId !== action.payload);
    },
    setAllSelected(state, action: PayloadAction<boolean>) {
      state.allSelected = action.payload;
      state.noneSelected = !action.payload;
    },
    setNoneSelected(state, action: PayloadAction<boolean>) {
      state.noneSelected = action.payload;
      if (action.payload) {
        state.selectedRows = [];
        state.selectedRowDetails = [];
        state.allSelected = false;
      }
    },
  },
});

export const {
  setSelectedRows,
  addSelectedRow,
  removeSelectedRow,
  clearSelectedRows,
  setSelectedRowDetails,
  addSelectedRowDetail,
  removeSelectedRowDetail,
  setAllSelected,
  setNoneSelected,
} = tableSelectionSlice.actions;

export default tableSelectionSlice.reducer;
